import React, { useState } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";
import { Link } from "react-router-dom";

const socialLinks = [
  { href: "https://www.facebook.com/staysafe.aa/", label: "Facebook", icon: FaFacebookF },
  { href: "https://x.com/StaySafeorg", label: "X", icon: FaXTwitter },
  { href: "https://www.instagram.com/StaySafe.aa/", label: "Instagram", icon: FaInstagram },
  { href: "https://www.linkedin.com/company/staysafe-aa/", label: "LinkedIn", icon: FaLinkedinIn },
  { href: "http://www.youtube.com/@staysafe5506", label: "YouTube", icon: FaYoutube },
  { href: "https://wa.me/0096171774241", label: "WhatsApp", icon: FaWhatsapp },
] as const;

const linkClass =
  "!text-[11px] !font-normal !leading-none !text-black transition-colors duration-200 hover:!text-[#3C79B4]";

const FooterAnimated: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <footer
      className="relative z-50 w-full overflow-hidden bg-white text-black"
      style={{ fontFamily: "Helvetica, sans-serif" }}
    >
      <div className="relative z-10 mx-auto w-full px-3 py-1 sm:px-4 md:px-6 md:py-1.5 lg:px-8 lg:py-2">
        <div
          onClick={() => setExpanded((open) => !open)}
          className="flex cursor-pointer flex-row items-center justify-between gap-1 md:gap-2 lg:gap-3"
        >
          <div className="text-[11px] font-normal leading-none">
            © {new Date().getFullYear()} Stay Safe Academy | CRN 3636017
          </div>

          <div className="flex flex-wrap items-center gap-2 md:gap-3 lg:gap-4">
            <a
              href="https://www.staysafeaa.org/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(event) => event.stopPropagation()}
              className={linkClass}
            >
              Privacy Policy
            </a>

            <div className="flex items-center gap-1 md:gap-2 lg:gap-3">
              {socialLinks.map(({ href, label, icon: Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  onClick={(event) => event.stopPropagation()}
                  className="inline-flex text-black transition-transform duration-200 hover:scale-125"
                >
                  <Icon className="h-3 w-3 lg:h-4 lg:w-4" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div
          inert={!expanded}
          className={`overflow-hidden transition-all duration-200 ease-out ${
            expanded ? "mt-2 max-h-[500px] opacity-100" : "max-h-0 translate-y-4 opacity-0"
          }`}
        >
          <div className="mb-3 grid grid-cols-2 gap-4 md:gap-5">
            <div>
              <h3 className="mb-1 !text-[11px] !font-bold !leading-snug !text-[#3C79B4]">Study</h3>
              <ul className="space-y-1">
                <li>
                  <Link to="/" onClick={(event) => event.stopPropagation()} className={linkClass}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/courses"
                    onClick={(event) => event.stopPropagation()}
                    className={linkClass}
                  >
                    My Courses
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterAnimated;
